module.exports = __webpack_public_path__ + "img/bank-generate-rule.03160859.svg";